import Hero from "./VisibilityComponents/hero";
import WhySection from "./VisibilityComponents/why";
import { WhatSection } from "./VisibilityComponents/what";
import ProcessSection from "./VisibilityComponents/process";
import GainsSection from "./VisibilityComponents/gain";
import PackagesSection from "./VisibilityComponents/package";
import Ads from "./VisibilityComponents/ads";
import ContactForm from "./VisibilityComponents/form";
import Review from "./VisibilityComponents/review";
import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/NavBar/NavBar";
import "./visibility.css";

const Visibility = () => {
  return (
    <div>
      <NavBar />
      <Hero
        heading="Less Talk. Results First."
        subheading="We help Nigerian businesses grow with proven digital strategies not empty promises."
      />
      <WhySection />
      <WhatSection />
      <ProcessSection />
      <GainsSection />
      <Ads />
      <PackagesSection />
      <Review />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Visibility;
